var _path, _g, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoonlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 220.507 220.454",
    enableBackground: "new 0 0 220.507 220.454",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 110.2271,
    x2: 220.5073,
    y2: 110.2271
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1BA3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA227A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M219.667,134.74c-13.798,50.215-55.77,84.47-104.987,85.68 c-50.437,1.235-95.566-31.55-110.136-80.014C-9.654,93.174,10.231,41.474,52.85,14.688c9.836-6.184,20.592-10.176,31.585-13.65 c1.812-1.182,4.469-1.671,5.113,0.27c1.241,3.75-3.026,4.744-4.814,7.017c-38.726,35.47-40.49,94.665-3.917,131.311 c36.409,36.48,96.171,34.893,131.523-3.541c1.985-2.168,3.568-4.699,5.335-7.053C221.851,129.718,220.375,132.361,219.667,134.74"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    fill: "#FFFFFF",
    d: "M213.179,34.82c-1.857-0.337-3.657-0.796-5.348-1.365 c-12.399-4.17-19.408-14.3-21.715-27.341c-0.219-1.235-2.001-1.236-2.22,0c-2.681,15.154-11.601,25.871-26.985,28.726 c-1.224,0.227-1.224,1.99,0,2.217c15.243,2.819,24.32,13.516,26.991,28.548c0.168,0.947,1.168,0.952,1.111,0.93 c0.546-0.001,1.014-0.394,1.108-0.932c1.359-7.752,5.178-18.285,15.645-24.434c3.345-1.962,7.185-3.352,11.415-4.13 c0.535-0.099,0.924-0.566,0.923-1.11C214.104,35.384,213.714,34.917,213.179,34.82z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M163.661,64.064c-4.386-1.455-7.287-4.723-8.699-9.241c-0.253-0.811-1.107-0.802-1.075-0.791 c-0.493,0-0.929,0.32-1.075,0.79c-1.368,4.367-4.23,7.707-8.7,9.237c-1.013,0.347-1.014,1.786,0.001,2.133 c4.439,1.52,7.32,4.834,8.7,9.242c0.255,0.812,1.107,0.8,1.077,0.79c0.494,0,0.93-0.322,1.075-0.794 c1.021-3.299,2.819-5.85,5.349-7.581c0,0,0,0,0,0c2.766-1.894,4.122-1.344,4.121-2.716 C164.433,64.647,164.122,64.217,163.661,64.064z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M148.577,12.64c-4.403-1.46-7.293-4.741-8.699-9.24c-0.254-0.811-1.108-0.802-1.076-0.791 c-0.492,0-0.929,0.32-1.075,0.791c-1.365,4.357-4.222,7.703-8.7,9.237c-1.013,0.347-1.014,1.786,0.001,2.133 c4.45,1.524,7.324,4.846,8.699,9.242c0.256,0.812,1.108,0.801,1.078,0.79c0.493,0,0.93-0.323,1.076-0.794 c1.688-5.462,5.09-7.325,5.349-7.581c2.756-1.89,4.121-1.353,4.12-2.717C149.348,13.223,149.037,12.793,148.577,12.64z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonlight);
export default __webpack_public_path__ + "static/media/moonlight.0a949230.svg";
export { ForwardRef as ReactComponent };